import { useRef, useContext } from "react";
import { Box } from "@mui/material";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
  Inject,
  Toolbar,
  ExcelExport,
  Group,
  Filter,
  Selection,
  Sort,
  Page,
} from "@syncfusion/ej2-react-grids";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { selectedContext } from "../../pages/ShipmentsReport";
import styles from "../../assets/css/modules/shipmentDetail.module.css";

const CustomLink = styled(Link)`
  color: var(--primary-color);
  font-weight: 500;
  text-decoration: none;
`;
// using react context may become more performant than passing state to props
const ReportsTable = (props) => {
  const { setSelected, selected } = useContext(selectedContext);
  let { rows, currentStatus } = props;
  let isDelivered = currentStatus === "delivered";

  const toolbarOptions = ["ExcelExport", "CsvExport"];
  const { t, i18n } = useTranslation("reports");
  const { language } = i18n;
  const gridInstance = useRef(null);

  const toolbarClick = (args) => {
    // eslint-disable-next-line default-case
    switch (args.item.text) {
      case "Excel Export":
        gridInstance.current.excelExport();
        break;
      case "CSV Export":
        gridInstance.current.csvExport();
        break;
    }
  };
  const handleRowSelection = (e) => {
    if (e.isHeaderCheckboxClicked === true) {
      if (Array.isArray(e.data)) {
        setSelected([...selected, ...e.data.map((shipment) => shipment.AWB)]);
      } else {
        setSelected([...selected, e.data.AWB]);
      }
    } else {
      setSelected((selected) => [...selected, e.data.AWB]);
    }
  };
  const handleRowDeSelection = (e) => {
    if (e.isHeaderCheckboxClicked === true) {
      setSelected([]);
    } else {
      setSelected(
        selected.filter((shipment) => {
          return shipment !== e.data.AWB;
        })
      );
    }
  };

  return (
    <Box>
      <GridComponent
        cssClass={styles["custom-grid-style"]}
        enableRtl={language === "ar" ? true : false}
        dataSource={rows}
        rowSelected={handleRowSelection}
        rowDeselected={handleRowDeSelection}
        selectionSettings={{ type: "checkbox" }}
        ref={gridInstance}
        toolbar={toolbarOptions}
        filterSettings={{ type: "Excel" }}
        allowSorting
        allowExcelExport
        enableStickyHeader
        allowFiltering
        allowGrouping
        toolbarClick={toolbarClick}
        allowPaging={true}
        pageSettings={{ pageCount: 5, pageSize: 10 }}
        tooltip={{ enable: true }}
      >
        <ColumnsDirective>
          <ColumnDirective width={70} type="checkbox"></ColumnDirective>
          <ColumnDirective
            template={(e) => {
              return <CustomLink to={`/shipment/${e.AWB}`}>{e.AWB}</CustomLink>;
            }}
            field="AWB"
            headerText={t("awb")}
            width="120"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          <ColumnDirective
            field="ToConsigneeName"
            headerText={t("consignee")}
            width="150"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          <ColumnDirective
            headerText={t("address")}
            width="150"
            field="ToAddress"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          <ColumnDirective
            headerText={t("phone")}
            field="ToPhone"
            width="260"
            clipMode="EllipsisWithTooltip"
            template={(e) => {
              return (
                <>
                  {e.ToPhone} {e.ToMobile ? `(${e.ToMobile})` : ""}
                </>
              );
            }}
          ></ColumnDirective>
          <ColumnDirective
            field="COD"
            headerText={t("COD")}
            width="150"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          <ColumnDirective
            field="SpecialInstuctions"
            headerText={t("specialInstructions")}
            width="350"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          <ColumnDirective
            field="StatusNameA"
            headerText={t("status")}
            width="150"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
          <ColumnDirective
            field="ReasonNameA"
            headerText={t("reason")}
            width="150"
            clipMode="EllipsisWithTooltip"
          ></ColumnDirective>
        </ColumnsDirective>
        <Inject
          services={[
            Toolbar,
            ExcelExport,
            Group,
            Page,
            Filter,
            Selection,
            Sort,
          ]}
        />
      </GridComponent>
    </Box>
  );
};

export default ReportsTable;
